import type React from 'react';
import { LayoutView } from './LayoutView';
import { useLayout } from './useLayout';

type LayoutProps = {
    children: React.ReactNode;
};

export const Layout: React.FC<LayoutProps> = (props) => {
    const logic = useLayout();

    return <LayoutView {...props} {...logic} />;
};
